import React from 'react';
import {
  Heading,
  Link,
  TextBoldness,
  Typography,
  getClassNameFactory,
} from '@dcl/ui';
import { TypographyTags } from '@dcl/ui/dist/elements/Typography';
import { LinkTypes } from '@dcl/ui/dist/elements/Link';
import { IContactHubPhoneSupport } from './ContactHubPhoneSupportTypes';
import './index.css';

import { boldTypes, types } from '@dcl/ui/dist/elements/Heading';
import { NewTabIcon } from '../icons/NewTabIcon';

export const ContactHubPhoneSupport: React.FC<IContactHubPhoneSupport> = (
  props
) => {
  const {
    countryName,
    phoneNumber,
    phoneText,
    timings,
    isFontLarge,
    supportHoursListSingle,
  } = props;

  const getClassName = getClassNameFactory(ContactHubPhoneSupport.displayName);

  return (
    <div className={getClassName({ descendantName: 'container' })}>
      {countryName ? (
        <div
          className={getClassName({ descendantName: 'countryNameContainer' })}
        >
          <Heading
            className={getClassName({ descendantName: 'countryName' })}
            type={types.Small}
            boldType={boldTypes.bold}
          >
            {countryName}
          </Heading>
        </div>
      ) : null}

      <div className={getClassName({ descendantName: 'contactLine' })}>
        <div
          className={getClassName({
            descendantName: isFontLarge ? 'phoneNumberLarge' : 'phoneNumber',
          })}
        >
          <Link
            href={`tel:${phoneNumber}`}
            data-testid={'phoneNumber'}
            type={LinkTypes.INLINE}
          >
            {phoneNumber}
          </Link>
        </div>
        {phoneText ? (
          <Typography
            tag={TypographyTags.SPAN}
            boldness={TextBoldness.Regular}
            className={getClassName({
              descendantName: 'phoneInlineText',
            })}
          >
            {phoneText}
          </Typography>
        ) : null}
      </div>

      {timings ? (
        <Typography
          tag={TypographyTags.SPAN}
          boldness={TextBoldness.Regular}
          className={getClassName({
            descendantName: 'timings',
          })}
        >
          <span
            dangerouslySetInnerHTML={{ __html: timings ?? '' }}
            className={getClassName({ descendantName: 'text' })}
          />
        </Typography>
      ) : null}

      {supportHoursListSingle?.map((supportItem, index) => {
        const keyValue = `${supportItem.buttonLink}-${index + 1}`;

        return (
          <div
            className={getClassName({
              descendantName: 'supportHoursLinkSingle',
            })}
          >
            <Link
              key={keyValue}
              href={supportItem.buttonLink}
              data-testid={'supportHoursLinkSingle'}
              type={LinkTypes.INLINE}
              newWindow={supportItem.newTab}
              iconRight={<NewTabIcon />}
            >
              {supportItem.buttonLabel}
            </Link>
          </div>
        );
      })}
    </div>
  );
};

ContactHubPhoneSupport.displayName = 'ContactHubPhoneSupport';
